import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right--sprite",
  "use": "arrow-right--sprite-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right--sprite\">\n<path d=\"M0.0761719 12.4866L1.25617 13.6666L7.92284 6.99992L1.25617 0.333252L0.0761719 1.51325L5.56284 6.99992L0.0761719 12.4866Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol